export interface BetaMenuLink {
  label: string;
  route: string;
  iconClass?: string;
}

export interface BetaMenuSection {
  id: string;
  title: string;
  subtitle: string;
  railRoute?: string;
  iconSrc?: string;
  iconClass?: string;
  iconAlt?: string;
  links: BetaMenuLink[];
}

/** Single source of truth for beta sidebar navigation (paths and labels). */
export const BETA_MENU_SECTIONS: BetaMenuSection[] = [
  {
    id: 'chat',
    title: 'X = Answers',
    subtitle: 'Chat Beautifully',
    iconSrc: 'assets/last-chat.svg',
    iconAlt: 'Chat',
    links: [
      { label: '6X ~ ExecutiveChat', iconClass: 'fa-solid fa-fire', route: '/multi-ai/executive-chat' },
      { label: '1X ~ ClariChat', iconClass: 'fa-solid fa-home', route: '/ai/clarichat' },
      { label: '2X ~ DoubleChat', iconClass: 'fa-solid fa-code-compare', route: '/ai/doublechat' },
    
      { label: '?X ~ Search', iconClass: 'fa-solid fa-magnifying-glass', route: '/library/search' }
      
      // iconSrc: 'assets/last-chat.svg',  iconAlt: 'Chat',{ label: 'Log In', iconClass: 'fa-solid fa-right-from-bracket', route: '/auth/log-in' }
    ]
  },
  {
    id: 'clarigen',
    title: 'Create',
    subtitle: 'Beautifully',
    iconSrc: 'assets/svg/media-library.svg',
    iconAlt: 'Guitar',
    links: [
      { label: 'Videos', iconClass: 'fa-solid fa-video', route: '/ai/videos' },
      { label: 'Images', iconClass: 'fa-solid fa-image', route: '/ai/images' },
      { label: 'Notes', iconClass: 'fa-solid fa-book', route: '/notes' },
      { label: 'Edit Images', iconClass: 'fa-solid fa-pencil', route: '/library/photo-lab' }
      
    ]
  },
  {
    id: 'instruments',
    title: 'Play',
    subtitle: 'Beautifully',
    iconSrc: 'assets/svg/slanted-guitar.svg',
    iconAlt: 'Instruments',
    links: [
    
      // { label: 'Library', iconClass: 'fa-solid fa-photo-film', route: '/iq/media-library' },
      { label: 'Calendar', iconClass: 'fa-solid fa-calendar', route: '/library/calendar' },
     
      { label: 'Intelligence', iconClass: 'fas fa-eye', route: '/multi-ai/iq' },
      { label: 'Personality', iconClass: 'fa-solid fa-user', route: '/multi-ai/personality' },
      { label: 'Dashboard', iconClass: 'fa-solid fa-gauge', route: '/ai/dashboard' },
      { label: 'Lineup', iconClass: 'fa-solid fa-robot', route: '/ai/roster' }
    ]
  }
];

/** URL path without query or hash. */
export function betaMenuPathFromRouterUrl(url: string): string {
  return url.split('?')[0].split('#')[0];
}

/** Whether the current path matches any link in the section (prefix match). */
export function betaSectionMatchesRoute(section: BetaMenuSection, path: string): boolean {
  return section.links.some((link) => path.startsWith(link.route));
}

/** First section that matches the path, for default active rail icon / panel. */
export function findActiveBetaSectionId(
  path: string,
  sections: readonly BetaMenuSection[] = BETA_MENU_SECTIONS
): string | null {
  const found = sections.find((sec) => betaSectionMatchesRoute(sec, path));
  return found?.id ?? null;
}
